import React from 'react'

import { Box, Typography } from '@mui/material'

const DevBanner: React.FC = () => {
  if (process.env.REACT_APP_CHANNEL !== 'development') return null

  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: 'error.main',
        py: 0.5,
        textAlign: 'center',
        zIndex: 9999,
        position: 'relative',
      }}
    >
      <Typography variant="caption" fontWeight={600} color="warning.contrastText">
        Este é um ambiente de desenvolvimento para testes
      </Typography>
    </Box>
  )
}

export default DevBanner
